import React from 'react';
import {useIntl} from 'react-intl';
import ErrorPage from '../../common/ErrorPage/ErrorPage';
import PageTitle from '../PageTitle';
import {ACCESS_LOCKED_ERROR_KEY, ACCESS_LOCKED_TITLE_KEY} from './constants';
import {useIsDashboardLinkVisible} from './hooks/useIsDashboardLinkVisible';

export function AccessLocked() {
    const intl = useIntl();
    const isDashboardLinkVisible = useIsDashboardLinkVisible();

    const titleKey = ACCESS_LOCKED_TITLE_KEY;
    const messageKey = ACCESS_LOCKED_ERROR_KEY;

    const customTitleMessage = intl.formatMessage({id: titleKey, defaultMessage: 'Access Locked'});
    const customErrorMessage = intl.formatMessage({id: messageKey, defaultMessage: 'Access locked due to too many attempts'});

    return (
        <>
            <PageTitle pageTitle={customTitleMessage} />
            <ErrorPage
                isDashboardLinkVisible={isDashboardLinkVisible}
                customTitleMessage={customTitleMessage}
                customErrorMessage={customErrorMessage}
            />
        </>
    );
}
